import { connect } from 'react-redux';
import {
	thunkDeleteChecklist,
	thunkFetchChecklistCounts,
	thunkFetchEventGroups,
	thunkReloadChecklist,
	thunkSaveChecklist,
} from '@/redux/actions';
import ChecklistEditor from './ChecklistEditor';

const msp = ({ events, checklists, groups }) => ({
	event: events.currentEvent,
	checklists: checklists.checklists,
	groups: groups.groups,
});

const mdp = dispatch => ({
	fetchGroups: eventID => dispatch(thunkFetchEventGroups(eventID, null, 'ChecklistEditor')),
	fetchChecklistCounts: checklistID => dispatch(thunkFetchChecklistCounts(checklistID)),
	saveChecklist: draft => dispatch(thunkSaveChecklist(draft)),
	deleteChecklist: checklistID => dispatch(thunkDeleteChecklist(checklistID)),
	reloadChecklist: checklistID => dispatch(thunkReloadChecklist(checklistID)),
});

export default connect(msp, mdp)(ChecklistEditor);
